import { z } from 'zod';
import { IDLE_THRESHOLD_MAX_SECONDS, IDLE_THRESHOLD_MIN_SECONDS } from '../types/agent-idle-thresholds.js';
import { CLASSIFICATION_AUDIENCES } from '../utils/activity-classification.js';
/**
 * `PUT /v1/admin/activity-idle-thresholds` body (ClickUp 14zf25zn5q9). Seconds,
 * not minutes, so the wire carries the stored unit; the UI edits whole minutes
 * and multiplies. The database's CHECK and set_agent_idle_threshold() enforce
 * the same rule, so this is the friendly error, not the only guard.
 */
export const UpdateIdleThresholdSchema = z.object({
    audience: z.enum(CLASSIFICATION_AUDIENCES),
    threshold_seconds: z
        .number()
        .int()
        .min(IDLE_THRESHOLD_MIN_SECONDS)
        .max(IDLE_THRESHOLD_MAX_SECONDS)
        .refine((s) => s % 60 === 0, 'threshold_seconds must be a whole number of minutes'),
});
//# sourceMappingURL=agent-idle-thresholds.js.map